import useUser from '../../../../../contexts/hooks/useUser'
import { trpc } from '../../../../../modules/trpc'
import { getColor } from '../utils/getColor'
import { getSortedTrackers } from '../utils/getSortedTrackers'

export type TrackersHook = ReturnType<typeof useTrackers>

const useTrackers = () => {
	const { user } = useUser()

	const { data, isLoading, refetch } = trpc.trackers.get.useQuery(
		{ userId: user?.id ?? 0 },
		{ enabled: !!user?.id, onSuccess: data => getSortedTrackers(data) }
	)

	const mutate = trpc.trackers.edit.useMutation({})

	const getBackgroundColors = (values: number[]) => {
		if (isLoading || !data) {
			return Array(values.length).fill('#23DF48')
		}

		return values.map(value => {
			const color = data
				.filter(tracker => tracker.enabled)
				.reduce((currentColor, tracker) => {
					if (value < tracker.value) {
						if (tracker.limitType === 'veryLow') {
							return getColor('veryLow')
						}
						if (tracker.limitType === 'low' && currentColor === '#5C95FF') {
							return getColor('low')
						}
					} else if (value > tracker.value) {
						if (tracker.limitType === 'veryHigh') {
							return getColor('veryHigh')
						}
						if (tracker.limitType === 'high' && currentColor === '#5C95FF') {
							return getColor('high')
						}
					}
					return currentColor
				}, '#5C95FF')

			return color
		})
	}

	return {
		data,
		isLoading,
		mutate,
		refetch,
		getBackgroundColors,
	}
}

export default useTrackers
